<div class="min-h-screen bg-bg-base text-text-primary antialiased flex flex-col relative overflow-hidden">
    <!-- Ambient Background Effects -->
    <div class="fixed inset-0 pointer-events-none overflow-hidden z-0">
        <div class="absolute -top-40 -right-40 w-96 h-96 bg-primary/5 rounded-full blur-[100px]"></div>
        <div class="absolute top-[40%] -left-40 w-[500px] h-[500px] bg-primary/5 rounded-full blur-[120px]"></div>
        <div class="absolute -bottom-40 right-20 w-[400px] h-[400px] bg-primary/5 rounded-full blur-[100px]"></div>
    </div>

    <div class="relative z-10">
        <!-- Broker Header -->
        <app-broker-header></app-broker-header>

        <!-- Main Dashboard Container -->
        <main class="mx-auto max-w-7xl w-full px-4 sm:px-6 lg:px-8 py-8 space-y-6">
            <!-- Tabs Navigation -->
            <div class="bg-surface-elevated rounded-2xl border border-border shadow-subtle p-2">
                <app-broker-tabs-navigation></app-broker-tabs-navigation>
            </div>

            <!-- Tabs Content -->
            <div class="bg-surface-elevated rounded-3xl border border-border shadow-subtle min-h-[500px]">
                <app-broker-tabs-content></app-broker-tabs-content>
            </div>
        </main>
    </div>
</div>